export default "__VITE_ASSET__8e14584f__"